<template>
  <div class="row custom-record">
    <div class="col-md-1">
      <input
        type="checkbox"
        v-model="isChecked"
        class="custom-checkbox"
        v-show="!recordData.isPrimary"
      />
    </div>
    <div class="col-md-2 custom-data">
      <span>{{ recordData.addressTypeName }}</span>
    </div>
    <div class="col-md-5 custom-data">
      <span>{{ recordData.addressLines }}</span>
      <span>{{ recordData.city }}, {{ recordData.stateProvinceName }} {{ recordData.postalCode }}</span>
    </div>
    <div class="col-md-2">
      <span v-show="recordData.isPrimary">(primary)</span>
    </div>
    <div class="col-md-1">
      <a
        href="#"
        @click="editItem"
      >edit</a>
    </div>
    <div class="col-md-1">
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-address-record',
  props: {
    recordData: Object
  },
  computed: {
    isChecked: {
      get() {
        return this.recordData.isChecked
      },
      set(value) {
        this.$emit(
          'itemChecked',
          {
            contactAddress: this.recordData.contactAddress,
            contact: this.recordData.contact,
            address: this.recordData.address
          },
          value
        )
      }
    }
  },
  methods: {
    editItem() {
      this.$emit('editItem', this.recordData)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-record {
  padding: 5px;
}
.custom-data {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-address-record.vue